module.exports = __webpack_public_path__ + "img/bookcase-livingroom-pc.efe30129.png";